import { render, staticRenderFns } from "./StudentResultRow.vue?vue&type=template&id=a6db6534&scoped=true"
import script from "./StudentResultRow.vue?vue&type=script&lang=js"
export * from "./StudentResultRow.vue?vue&type=script&lang=js"
import style0 from "./StudentResultRow.vue?vue&type=style&index=0&id=a6db6534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6db6534",
  null
  
)

export default component.exports